// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"checkbox-group_fieldset__2PN2h","options":"checkbox-group_options__M2Ctr"};